import { render } from "./Update.vue?vue&type=template&id=c37b1c70&ts=true"
import script from "./Update.vue?vue&type=script&lang=ts"
export * from "./Update.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__